const TAG_RE = /^[a-zA-Z0-9][a-zA-Z0-9 _.-]{0,47}$/;

export function normalizeTag(raw) {
  const t = String(raw || '').trim().replace(/\s+/g, ' ');
  if (!t || !TAG_RE.test(t)) return null;
  return t;
}

/** Normalize tags from array, comma-separated string, or JSON array string. */
export function normalizeTags(raw) {
  const out = [];
  const seen = new Set();
  const add = (value) => {
    const tag = normalizeTag(value);
    if (!tag) return;
    const key = tag.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    out.push(tag);
  };

  if (Array.isArray(raw)) {
    raw.forEach(add);
  } else if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) parsed.forEach(add);
        else add(trimmed);
      } catch {
        trimmed.split(/[,;]/).forEach(add);
      }
    } else {
      trimmed.split(/[,;]/).forEach(add);
    }
  }
  return out;
}

export function tagsToDisplay(tags) {
  return normalizeTags(tags).join(', ');
}

export function rowHasTag(tags, filter) {
  if (!filter) return true;
  const needle = String(filter).trim().toLowerCase();
  if (!needle) return true;
  return normalizeTags(tags).some((t) => t.toLowerCase() === needle);
}

export function collectTagsFromRows(rows, tagKey = '__tags') {
  const set = new Set();
  for (const row of rows || []) {
    normalizeTags(row[tagKey]).forEach((t) => set.add(t));
  }
  return [...set].sort((a, b) => a.localeCompare(b));
}
